export default "__VITE_ASSET__B1G5Z8xb__"